import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import MapController from './MapController';
import API from '../API/mainApi';

const Map = ({ mode = 'view', onMarkerClick }) => {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const [map, setMap] = useState(null);
  const [serverPoints, setServerPoints] = useState([]);
  const edges = useSelector(state => state.mapEdges);
  const debounceTimer = useRef(null);

  const fetchMarkers = useCallback(async (bounds) => {
    if (!bounds.left || !bounds.right || !bounds.top || !bounds.bottom) return;
    const params = {
      Lat_top: bounds.top.lat,
      Lat_bottom: bounds.bottom.lat,
      Lon_right: bounds.right.lng,
      Lon_left: bounds.left.lng
    };
    const response = await API.getMarks(params);
    if (response.status === 200 && Array.isArray(response.data?.data)) {
      // console.log(response.data?.data);
      
      const formattedPoints = response.data.data.map(marker => ({
        lat: marker.Latitude,
        lng: marker.Longitude,
        driver_id: marker.ID
      }));
      // console.log(formattedPoints);
      setServerPoints(formattedPoints);
    } else {
      console.error('Ошибка загрузки меток:', response.err);
    }
  }, []);

  useEffect(() => {
    if (debounceTimer.current) clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      if (edges.left && edges.right && edges.top && edges.bottom) {
        fetchMarkers(edges);
      }
    }, 2000);
    return () => clearTimeout(debounceTimer.current);
  }, [edges, fetchMarkers]);

  useEffect(() => {
    let mounted = true;
    let cleanupListener = null;

    const initMap = async () => {
      if (!mounted || !containerRef.current || !window.ymaps3) return;
      try {
        await window.ymaps3.ready;
        if (!mounted || !containerRef.current) return;
        const { YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer } = window.ymaps3;
        const newMap = new YMap(containerRef.current, {
          location: { center: [37.64, 55.76], zoom: 15 },
          theme: 'dark',
          behaviors: ['drag', 'scrollZoom', 'pinchZoom', 'dblClick', 'magnifier'],
        });
        newMap.addChild(new YMapDefaultSchemeLayer());
        newMap.addChild(new YMapDefaultFeaturesLayer());
        mapRef.current = newMap;
        setMap(newMap);
      } catch (error) {
        console.error('Ошибка инициализации Яндекс.Карт v3:', error);
      }
    };

    if (window.ymaps3) {
      initMap();
    } else {
      const script = document.querySelector('script[src*="api-maps.yandex.ru"]');
      if (script) {
        const handleLoad = () => initMap();
        const handleError = () => console.error('API Яндекс.Карт не загружен');
        script.addEventListener('load', handleLoad);
        script.addEventListener('error', handleError);
        cleanupListener = () => {
          script.removeEventListener('load', handleLoad);
          script.removeEventListener('error', handleError);
        };
      } else {
        console.error('Не найден <script> Яндекс.Карт в index.html');
      }
    }

    return () => {
      mounted = false;
      if (cleanupListener) cleanupListener();
      if (mapRef.current) {
        mapRef.current.destroy();
        mapRef.current = null;
      }
    };
  }, []);

  return (
    <div style={{ height: '100vh', width: '100%', position: 'relative' }}>
      <div ref={containerRef} style={{ height: '100%', width: '100%' }} />
      {map && (
        <MapController
          map={map}
          mode={mode}
          serverPoints={serverPoints}
          onMarkerClick={onMarkerClick}
        />
      )}
    </div>
  );
};

export default Map;